import moment from 'moment-timezone';
import {
    ORDERS_PROGRESS_REQUEST,
    ORDERS_PROGRESS_RECEIVE,

    ORDERS_PROGRESS_SET_SORTING
} from './actions';

import { ORDERS_HIDE_IN_LISTS } from './../orders/actions';

const sorting = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_PROGRESS_SET_SORTING:
            return Object.assign({}, state, {
                field: action.value,
                isAsc: state.field === action.value ? !state.isAsc : true
            });
        default:
            return state;
    }
}

const ordersProgress = (state = {
    isFetching: false,
    didInvalidate: true,
    numbers: [],
    sorting: { field: 'pregrader_created_at', isAsc: true },
}, action) => {
    switch (action.type) {
        case ORDERS_HIDE_IN_LISTS:
            return Object.assign({}, state, {
                numbers: state.numbers.filter(number => number !== action.number)
            });
        case ORDERS_PROGRESS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case ORDERS_PROGRESS_RECEIVE:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                updatedAt: moment(),
                numbers: action.numbers
            });
        case ORDERS_PROGRESS_SET_SORTING:
            return Object.assign({}, state, {
                sorting: sorting(state.sorting, action)
            });
        default:
            return state;
    }
};

export default ordersProgress;


// WEBPACK FOOTER //
// ./src/store/ordersProgress/reducers.js